/**
 * "Telefon düzeni": dokunmatik cihaz YA DA dar pencere (≤ 760 px). Bu düzende ekran kumandaları görünür
 * (fareyle de çalışır), üst çubuk logo sol / ses / Menü sağ olur. CSS'teki eş medya sorgusuyla aynı tutulur.
 */
export const MOBILE_QUERY = '(pointer: coarse), (max-width: 760px)'

const query = window.matchMedia(MOBILE_QUERY)

export function isMobileLayout()
{
    return query.matches
}

export function onMobileLayoutChange(_callback)
{
    query.addEventListener('change', () => _callback(query.matches))
}
